import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UserService } from '../services/user/user.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProjectGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const accessTokens = localStorage.getItem('userToken');
    const projectID = route.paramMap.get('projectid'); // Get project ID from URL
    const type = localStorage.getItem('userType');
    debugger
    if (type == "Admin") {
      return of(true)
    }
    if (!accessTokens || !projectID) {
      return this.redirectAndDeny();
    }
    // Fetch current user data based on token
    return this.userService.getCurrentUserData(accessTokens).pipe(
      switchMap((userData: any) => {
        if (userData && userData.accessToken && userData !== 'false') {
          // Fetch project assignment details
          return this.userService.getAssignedProjects(projectID, userData.id).pipe(
            map((projectData: any) => {
              if (projectData) {
                return true; // User has access
              } else {
                this.redirectAndDeny();
                return false;
              }
            }),
            catchError(() => {
              this.redirectAndDeny();
              return of(false);
            })
          );
        } else {
          this.redirectAndDeny();
          return of(false);
        }

      }),
      catchError(() => {
        this.redirectAndDeny();
        return of(false);
      })
    );
  }
  private redirectAndDeny(): Observable<boolean> {
    this.router.navigate(['/projectdashboard']);
    return of(false);
  }
}
